<template>
  <div>
    <div v-if="Object.keys(errors).length > 0" class="alert alert-danger">
      <p v-for="error in errors" class="errors">
        {{ error }}
      </p>
    </div>
    <div :class="{'has-error':errors.variable}">
      <select name="language" :value="language" class="form-control" @change="handleChange">
        <option value="" selected="selected">
          Select a Language
        </option>
        <option v-for="(locale, $id) in config.studyLocales" :value="$id">
          {{ locale }}
        </option>
      </select>
    </div>
  </div>
</template>
<script type="text/javascript">
  import BaseComponent from '@/EventLogic/components/BaseComponent.vue';

  export default {
    extends: BaseComponent,

    props: {
      language: String,
      id: String
    },
    methods: {
      validate: function() {
        this.errors = {};

        if (!this.language) {
          this.errors.dataClassification = 'Please select a language.';
        }

        return Object.keys(this.errors).length === 0;
      }
    }
  };
</script>
